import { Injectable, NgZone } from '@angular/core';
import { TranslationService } from '../translation/translation.service';

@Injectable({ providedIn: 'root' })
export class EditorI18nService {
  constructor(private translationService: TranslationService) { }

  translateAll(): void {
    document.querySelectorAll('.angular-editor-toolbar [title]')
      .forEach(elem => {
        const title = elem.getAttribute('title');
        if (title) {
          elem.setAttribute('title', this.translationService.translate(title));
        }
      });
  }
}
